import EventBus from '@/eventBus';

export const CartHelpersVue = {
    data() {
        return {

        }
    },

    methods: {
        setCartId(cartId) {
            if (!$.cookie('cartId')) {
                return $.cookie('cartId', cartId, {
                    expires: 300,
                    path: '/'
                });
            }
        },

        getCartId() {
            return $.cookie('cartId');
        },

        getMiniCart(cartId) {
            this.req('Common:getMiniCart', {
                cartId
            }, res => {
                if (this.checkProperty(res.countProductsToCart)) {
                    let count = res.countProductsToCart;

                    this.$nextTick(() => {
                        $('.cart-widget__count-num').text(count);
                        if (count > 0) {
                            $('.cart-widget').addClass('cart-widget--active');
                            $('.cart-widget__count').removeClass('cart-widget__count--hide');
                        } else {
                            $('.cart-widget').removeClass('cart-widget--active');
                            $('.cart-widget__count').addClass('cart-widget__count--hide');
                        }
                    });
                }
            }, '', 'localPageRequest');
        },

        getAmount(input, type, minAmount) {
            minAmount = (typeof(minAmount) === 'undefined') ? 1 : minAmount;

            let amount = $(input).val();

            if (type === 'minus') {
                amount = amount > minAmount ? --amount : minAmount;
            }

            if (type === 'plus') {
                amount++;
            }

            return amount;
        },

        addToCart(callback, params) {
            this.req('CartPage:addToCart', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        },

        removeFromCart(callback, params) {
            this.req('CartPage:removeFromCart', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        },

        clearCart(callback, params) {
            this.req('CartPage:clearCart', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        },

        saveDeliveryAddress(callback, params) {
            this.req('CartPage:saveDeliveryAddress', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        },

        cartStep(path) {
            this.$router.push({
                path: path
            });
        },

        savePaymentMethod(callback, params) {
            this.req('CartPage:savePaymentMethod', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        },

        checkout(callback, params) {
            this.req('CartPage:checkout', { ...params
            }, res => {
                if ($.isFunction(callback)) {
                    callback(res);
                }
            }, '', 'localPageRequest');
        }
    }
};